module.exports = {
	"ru": null
};


//////////////////
// WEBPACK FOOTER
// ./src/routes/strings.yaml
// module id = 778
// module chunks = 0